/* KCPC image protection - sirf images lock, text/SKU normal rahega */
(function () {
  var css = 'img{-webkit-user-drag:none;user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;}';
  try {
    var s = document.createElement('style');
    s.setAttribute('data-kcpc', 'image-lock');
    s.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}

  function isImage(el) {
    return el && el.closest && el.closest('img');
  }

  document.addEventListener('contextmenu', function (e) {
    if (isImage(e.target)) e.preventDefault();
  }, false);

  document.addEventListener('dragstart', function (e) {
    if (isImage(e.target)) e.preventDefault();
  }, false);
})();